import React, { FC }from 'react';
import styled from '@emotion/native';
import { View } from 'react-native';

const Container = styled(View)`
  flex-direction: column;
  background-color: ${({ theme, ...props }: any) => 'transparent' };

  ${props => props?.bg && `
    background-color: ${props?.bg};
  `};

  ${props =>   ` width: ${props.theme.contentWidth}px; `}
  ${props => props?.inset && `
    width: ${props.theme.contentWidth - 30}px;
  `}
`;

type Props = {
  title?: string;
  children?: React.ReactNode;
  inset?: boolean;
  bg?: string;
};

const Pane: FC<Props> = ({ children, title,...props }) => {

  return (
      <Container {...props}>
        {children}
      </Container>
  );
}

export default Pane;